<!-- <p>vjs-player works!</p> -->

<video #target class="video-js" controls muted playsinline preload="none"></video>